import { render, staticRenderFns } from "./BankProfile.vue?vue&type=template&id=f4f471e8"
import script from "./BankProfile.vue?vue&type=script&lang=js"
export * from "./BankProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports